import $ from 'static/script/libs/jquery';

function isVisible(breakpoint) {
    return $(breakpoint).css('display') === 'block';
}
function getCurrent() {
    let sizes = ['xxlarge', 'xlarge', 'large', 'medium', 'small'];
    for (let i = 0; i < sizes.length; i++) {
        let breakpoint = '#breakpoint-' + sizes[i];
        if (isVisible(breakpoint)) {
            return sizes[i];
        }
    }
}

module.exports = {
    isVisible : isVisible,
    getCurrent: getCurrent,
    small: '#breakpoint-small',
    medium: '#breakpoint-medium',
    large: '#breakpoint-large',
    xlarge: '#breakpoint-xlarge',
    xxlarge: '#breakpoint-xxlarge',
    siteheader: '#breakpoint-siteheader',
    siteheaderportrait: '#breakpoint-siteheaderportrait',
    sidebarsearch: '#breakpoint-sidebarsearch'
};


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/utils/breakpoints.js